import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import LoadScript from 'vue-plugin-load-script';
import LazyTube from "vue-lazytube";

Vue.use(LoadScript);
Vue.use(LazyTube)
Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
